import eventSourcePolyfill from 'eventsource';
import { BASE_URL } from '@/assets/js/config';
import { getAccessToken } from '@/assets/js/auth';

export const subscribeToEventSource = async (callback) => {
  const settings = {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`
    },
  };

  let source = new eventSourcePolyfill(`${BASE_URL}/events`, settings);
  source.onmessage = callback;
}